<template>
  <formulaire-view
    :steps="steps"
    :step="step"
    url="/demande-inscription-registre-etudiant/"
    paramsName="registre_etudiant"
    :endpoint="endpoint"
    showPanier
    :getRefs="$refs"
  >
    <template v-slot:step="{ sas, path, setState, code }">
      <component
        :is="path"
        :sas="sas"
        @validation-changed="setState(path, $event)"
        :ref="path"
        :endpoint="endpoint"
      >
        <ressource :code="code" />
      </component>
    </template>
  </formulaire-view>
</template>

<script>
import FormulaireView from "@/views/FormulaireView.vue"

import Identification from "@/components/Formulaires/DemandeInscriptionRegistreEtudiant/Identification"
import InscriptionRegistre from "@/components/Formulaires/DemandeInscriptionRegistreEtudiant/InscriptionRegistre"
import ConsentementCommunication from "@/components/Formulaires/DemandeInscriptionRegistreEtudiant/ConsentementCommunication"
import Declaration from "@/components/Formulaires/DemandeInscriptionRegistreEtudiant/Declaration"

export default {
  props: {
    step: String
  },
  data() {
    return {
      endpoint: "demande-inscription-registre-etudiant",
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "identification", code: "titre-etape-1", state: "" },
        { path: "inscription-registre", code: "titre-etape-2", state: "" },
        { path: "consentement-communication", code: "titre-etape-3", state: "" },
        { path: "declaration", code: "titre-etape-4", state: "" },
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },

  components: {
    FormulaireView,
    Identification,
    Declaration,
    InscriptionRegistre,
    ConsentementCommunication
  }
}
</script>